import template from './liabilities.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    liabilities: '<',
    assets: '<',
    contacts: '<',
    workflow: '<',
    homeLoanSecurityDetails: '<',
    lenders: '<',
    idTicket: '<',
    validationErrors: '<',
    isDealOwnerBroker: '<',
    haveLendersExisting: '<',
    isTicketSettled: '<',
    onChangedLinkedAsset: '&',
    onFinished: '&',
    onValidated: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      eventService,
      helperService,
      liabilitiesService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableLiabilityTypes = [];
      ctrl.liabilitiesEstimate = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || null;
        ctrl.homeLoanSecurityDetails = ctrl.homeLoanSecurityDetails || null;
        ctrl.lenders = ctrl.lenders || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.idItem = ctrl.idTicket || ctrl.contacts[0]?.id || '';
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.haveLendersExisting = ctrl.haveLendersExisting || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(ctrl.assets);
        if (ctrl.liabilities?.length) {
          ctrl.getLiabilitiesEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.isLiabilityUsedInHomeLoan = (idLiability) => {
        if (ctrl.homeLoanSecurityDetails && ctrl.homeLoanSecurityDetails.otherMortgages) {
          return helperService.isLiabilityUsedInHomeLoan(
            ctrl.homeLoanSecurityDetails.otherMortgages,
            idLiability,
            ctrl.isDealOwnerBroker,
            ctrl.haveLendersExisting
          );
        }
        return false;
      };

      ctrl.liabilityAdd = (type) => {
        const liabilityType = type;
        delete liabilityType.isDisabled;
        liabilitiesService.liabilityAdd(ctrl.liabilities, liabilityType, ctrl.contacts);
        ctrl.onValidated();
      };

      ctrl.liabilityDelete = (liability) => {
        const idx = helperService.findIndexById(ctrl.liabilities, liability.id);
        if (idx > -1) {
          ctrl.liabilities = liabilitiesService.liabilityDelete(ctrl.liabilities, idx);
          ctrl.saveLiabilities();
        }
      };

      ctrl.getLastIndex = (data, idType) => helperService.getLastIndex(data, idType);

      ctrl.totalLiabilitiesBalancePerContact = (idContact) =>
        liabilitiesService.getTotalLiabilitiesBalancePerContact(ctrl.liabilities, idContact);

      ctrl.totalLiabilitiesExistingRepaymentPerContact = (idContact) =>
        liabilitiesService.getTotalExistingLiabilitiesRepaymentPerContact({
          liabilities: ctrl.liabilities,
          workflow: ctrl.workflow,
          idContact
        });

      ctrl.changeLinkedAsset = (liability) => {
        if (
          ctrl.isDealOwnerBroker &&
          $rootScope.hasBrokerToolsEnabled() &&
          ctrl.haveLendersExisting &&
          ctrl.workflow.isHomeLoan()
        ) {
          ctrl.onChangedLinkedAsset({ liability });
        } else {
          ctrl.saveLiabilities(liability);
        }
      };

      ctrl.totalLiabilitiesByContact = ({ idContact, path }) => {
        const totalLiabilities = _.find(
          ctrl.liabilitiesEstimate?.contacts || [],
          (i) => i?.id === idContact
        );
        return totalLiabilities ? totalLiabilities[path] || 0 : 0;
      };

      ctrl.getLiabilitiesEstimate = () => {
        ctrl.isProcessing = true;
        financesService
          .getLiabilities({ id: ctrl.idItem, type: ctrl.idTicket ? 'ticket' : 'contact' })
          .then((res) => {
            ctrl.isProcessing = false;
            if (res?.status) {
              ctrl.liabilitiesEstimate = res?.liabilities || {};
            }
          });
      };

      ctrl.saveLiabilities = _.debounce((liability) => {
        if (liability) {
          const idx = helperService.findIndexById(ctrl.liabilities, liability.id);
          if (idx > -1) {
            ctrl.liabilities.splice(idx, 1);
            ctrl.liabilities.splice(idx, 0, liability);
          } else {
            ctrl.liabilities.push(liability);
          }
        }
        const data = {
          liabilities: ctrl.liabilities,
          tCD: 'liabilities'
        };
        ctrl.onFinished({ data });
      }, 3000);

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'liabilities') {
          ctrl.getLiabilitiesEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
